import React, { useState } from 'react';
import { 
    Container, Typography, Box, Grid, TextField, Button, Paper, Alert, CircularProgress 
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import api from '../../../services/api';

const ContactPage = () => {
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess(false);

        try {
            await api.post('/public/contact', formData);
            setSuccess(true);
            setFormData({ name: '', email: '', subject: '', message: '' }); // Reset form
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send message. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ py: 8, minHeight: '80vh', bgcolor: 'background.default' }}>
            <Container maxWidth="lg"> {/* Changed from md to lg for more width overall */}
                <Typography variant="h3" align="center" fontWeight="bold" gutterBottom color="primary">
                    Get in Touch
                </Typography>
                <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 6 }}>
                    Have questions about bursaries or the platform? We're here to help.
                </Typography>

                <Grid container spacing={4}>
                    {/* Contact Info Side - Expanded Width */}
                    <Grid item xs={12} md={5}> {/* Changed from md={4} to md={5} */}
                        <Paper sx={{ p: 4, height: '100%', bgcolor: 'primary.main', color: 'white' }}>
                            <Typography variant="h6" gutterBottom>Contact Information</Typography>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, mt: 3 }}>
                                <EmailIcon sx={{ mr: 2, flexShrink: 0 }} />
                                <Typography sx={{ wordBreak: 'break-word' }}>
                                    support@brightsparc.co.za
                                </Typography>
                            </Box>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocationOnIcon sx={{ mr: 2, flexShrink: 0 }} />
                                <Typography>
                                    Johannesburg, South Africa
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    {/* Form Side - Adjusted Width */}
                    <Grid item xs={12} md={7}> {/* Changed from md={8} to md={7} */}
                        <Paper sx={{ p: 4 }}>
                            {success && <Alert severity="success" sx={{ mb: 3 }}>Message sent! We'll be in touch shortly.</Alert>}
                            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
                            
                            <Box component="form" onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField 
                                            required fullWidth label="Your Name" name="name" 
                                            value={formData.name} onChange={handleChange} 
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField 
                                            required fullWidth label="Email Address" name="email" type="email" 
                                            value={formData.email} onChange={handleChange} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField 
                                            fullWidth label="Subject" name="subject" 
                                            value={formData.subject} onChange={handleChange} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField 
                                            required fullWidth label="Message" name="message" multiline rows={4} 
                                            value={formData.message} onChange={handleChange} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button 
                                            type="submit" variant="contained" size="large" fullWidth 
                                            disabled={loading} endIcon={loading ? <CircularProgress size={20} color="inherit"/> : <SendIcon />}
                                        >
                                            {loading ? 'Sending...' : 'Send Message'}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default ContactPage;